import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

const ago = (iso) => {
  if (!iso) return "never";
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  return m < 60 ? `${m} min ago` : `${Math.round(m / 6) / 10} h ago`;
};

export const WooSyncAlert = () => {
  const [st, setSt] = useState(null);
  useEffect(() => {
    const load = () => Promise.all([api.get("/woocommerce/integration-health"), api.get("/woocommerce/sync-health")])
      .then(([h, s]) => setSt({ h: h.data, s: s.data })).catch(() => setSt(null));
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);
  if (!st || (st.h.status === "ok" && st.s.healthy)) return null;
  const blocked = st.h.status !== "ok";
  const backlog = !blocked && st.s.issue === "import_backlog";
  const err = st.h.last_error;
  return (
    <div className="mb-6 flex flex-wrap items-start gap-3 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3" data-testid="woo-sync-alert">
      <AlertTriangle className="w-5 h-5 text-rose-600 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-[200px] text-sm text-rose-900">
        <div className="font-semibold" data-testid="woo-sync-alert-title">
          {blocked ? `WooCommerce scheduled fetch is ${st.h.status}` : backlog ? "Some WooCommerce orders failed to import" : "WooCommerce scheduled fetch has not succeeded recently"}
        </div>
        <div className="text-rose-800/80 break-words" data-testid="woo-sync-alert-detail">
          {blocked ? (st.h.reason || "Upstream request failed.") : st.s.message} Last successful sync {ago(st.h.last_success_at || st.s.last_successful_fetch)}
          {st.h.consecutive_failures ? ` · ${st.h.consecutive_failures} failed attempt(s)` : ""}
          {blocked && st.h.next_retry_at ? ` · next retry ${new Date(st.h.next_retry_at).toLocaleTimeString("en-GB")}` : ""}.
          {err && <span className="block text-xs text-rose-700/80 mt-0.5" data-testid="woo-sync-alert-last-error">Last error {ago(err.at)} ({err.source}): {err.reason}</span>}
        </div>
      </div>
      <Link to="/stock/woocommerce" className="text-sm font-medium text-rose-700 hover:underline shrink-0" data-testid="woo-sync-alert-link">Open WooCommerce</Link>
    </div>
  );
};
